<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <blogDetailBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import blogDetailBannerComponent from '../blogDetail/blogDetailBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'blogDetailComponent',
  components: {
    headerComponent,
    blogDetailBannerComponent,
    footerComponent,
  },
};
</script>
